import { connect } from 'react-redux';
import { selectLocaleData } from 'selectors/locale-data';
import RecurringSchedule from './RecurringSchedule';

const mapStateToProps = (state, ownProps) => {
  const { offsetDaysOfWeek } = selectLocaleData(state);

  return {
    ...ownProps,
    daysOfWeek: offsetDaysOfWeek,
  };
};

export default connect(mapStateToProps)(RecurringSchedule);
